// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_wrk_client = require("./MM_wrk_client.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_wrk_ctx_data = require("./MM_wrk_ctx_data.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_wrk_pre_ctx_data = require("./MM_wrk_pre_ctx_data.res.js");

var procName = "MM_wrk_ctx";

function reqToStr(req) {
  switch (req.TAG) {
    case "PrepareWrkPrecalcData" :
        return "PrepareWrkPrecalcData";
    case "SetSettings" :
        return "SetSettings(settingsVer=" + String(req.settingsVer) + ")";
    case "SetPreCtx" :
        return "SetPreCtx(preCtxVer=" + String(req.preCtxVer) + ")";
    
  }
}

function respToStr(resp) {
  if (typeof resp !== "object") {
    return "Ok";
  } else if (resp.TAG === "GetSettings") {
    return "GetSettings(settingsVer=" + String(resp.settingsVer) + ")";
  } else {
    return "GetPreCtx(preCtxVer=" + String(resp.preCtxVer) + ")";
  }
}

var wrkPrecalcData = {
  contents: undefined
};

function getSettingsExn() {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.settings;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "settings are not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkCtxExn() {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.wrkCtx;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "wrkCtx is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkParenCntExn() {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.wrkParenCnt;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "wrkParenCnt is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getWrkFrmsExn() {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.wrkFrms;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "wrkFrms is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getAllFramesInDeclarationOrderExn() {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.allFramesInDeclarationOrder;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "wrkFrms is not created in the worker thread."
        },
        Error: new Error()
      };
}

function getSyntaxTypesExn() {
  var match = wrkPrecalcData.contents;
  if (match !== undefined) {
    return match.syntaxTypes;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "syntaxTypes are not created in the worker thread."
        },
        Error: new Error()
      };
}

var settingsCache = Common.cacheMake((function (settings) {
        return settings;
      }), (function (v1, v2) {
        return v1 === v2;
      }));

var preCtxCache = Common.cacheMake((function (ctx) {
        return ctx;
      }), (function (v1, v2) {
        return v1 === v2;
      }));

var frmsCache = Common.cacheMake((function (ctx) {
        return MM_substitution.prepareFrmSubsData(ctx);
      }), (function (ctxV1, ctxV2) {
        return ctxV1 === ctxV2;
      }));

var parenCntCache = Common.cacheMake((function (param) {
        return MM_provers.makeParenCnt(param[1], param[0].parens);
      }), (function (param, param$1) {
        if (param[0] === param$1[0]) {
          return param[1] === param$1[1];
        } else {
          return false;
        }
      }));

var allFramesInDeclarationOrderCache = Common.cacheMake((function (frms) {
        return Expln_utils_common.sortInPlaceWith(MM_substitution.frmsSelect(frms, undefined, undefined), (function (a, b) {
                        return a.frame.ord - b.frame.ord | 0;
                      })).map(function (frm) {
                    return frm.frame;
                  });
      }), (function (ctxV1, ctxV2) {
        return ctxV1 === ctxV2;
      }));

var syntaxTypesCache = Common.cacheMake((function (ctx) {
        return MM_wrk_pre_ctx_data.findTypes(ctx)[1];
      }), (function (ctxV1, ctxV2) {
        return ctxV1 === ctxV2;
      }));

function makeWrkPrecalcData(settingsVer, preCtxVer, varsText, disjText) {
  var settings = Common.cacheGetByDepVer(settingsCache, settingsVer);
  if (settings === undefined) {
    return {
            TAG: "Error",
            _0: {
              TAG: "GetSettings",
              settingsVer: settingsVer
            }
          };
  }
  var preCtx = Common.cacheGetByDepVer(preCtxCache, preCtxVer);
  if (preCtx === undefined) {
    return {
            TAG: "Error",
            _0: {
              TAG: "GetPreCtx",
              preCtxVer: preCtxVer
            }
          };
  }
  var preCtx$1 = Caml_option.valFromOption(preCtx);
  var wrkCtx = MM_wrk_ctx_data.createWrkCtx(preCtx$1, varsText, disjText);
  if (wrkCtx.TAG === "Ok") {
    var wrkFrms = Common.cacheGet(frmsCache, preCtxVer, preCtx$1);
    return {
            TAG: "Ok",
            _0: {
              settings: settings,
              wrkFrms: wrkFrms,
              wrkParenCnt: Common.cacheGet(parenCntCache, [
                    settingsVer,
                    preCtxVer
                  ], [
                    settings,
                    preCtx$1
                  ]),
              wrkCtx: wrkCtx._0,
              allFramesInDeclarationOrder: Common.cacheGet(allFramesInDeclarationOrderCache, preCtxVer, wrkFrms),
              syntaxTypes: Common.cacheGet(syntaxTypesCache, preCtxVer, preCtx$1)
            }
          };
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "There was an error creating wrkCtx in the worker thread."
        },
        Error: new Error()
      };
}

function processOnWorkerSide(req, sendToClient) {
  switch (req.TAG) {
    case "PrepareWrkPrecalcData" :
        wrkPrecalcData.contents = undefined;
        var resp = makeWrkPrecalcData(req.settingsVer, req.preCtxVer, req.varsText, req.disjText);
        if (resp.TAG !== "Ok") {
          return sendToClient(resp._0);
        }
        wrkPrecalcData.contents = resp._0;
        return sendToClient("Ok");
    case "SetSettings" :
        Common.cacheGet(settingsCache, req.settingsVer, req.settings);
        return ;
    case "SetPreCtx" :
        Common.cacheGet(preCtxCache, req.preCtxVer, req.preCtx);
        return ;
    
  }
}

function beginWorkerInteractionUsingCtx(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, procName$1, initialRequest, onResponse, enableTraceOpt) {
  var enableTrace = enableTraceOpt !== undefined ? enableTraceOpt : false;
  var prepareWrkPrecalcDataReq = {
    TAG: "PrepareWrkPrecalcData",
    settingsVer: settingsVer,
    preCtxVer: preCtxVer,
    varsText: varsText,
    disjText: disjText
  };
  MM_wrk_client.beginWorkerInteraction(procName, prepareWrkPrecalcDataReq, (function (resp, sendToWorker, endWorkerInteraction) {
          if (typeof resp === "object") {
            if (resp.TAG === "GetSettings") {
              if (resp.settingsVer === settingsVer) {
                sendToWorker({
                      TAG: "SetSettings",
                      settingsVer: settingsVer,
                      settings: settings
                    });
                return sendToWorker(prepareWrkPrecalcDataReq);
              } else {
                return ;
              }
            } else if (resp.preCtxVer === preCtxVer) {
              sendToWorker({
                    TAG: "SetPreCtx",
                    preCtxVer: preCtxVer,
                    preCtx: preCtx
                  });
              return sendToWorker(prepareWrkPrecalcDataReq);
            } else {
              return ;
            }
          }
          endWorkerInteraction();
          MM_wrk_client.beginWorkerInteraction(procName$1, initialRequest, onResponse, enableTrace, undefined, undefined);
        }), enableTrace, undefined, undefined);
}

exports.procName = procName;
exports.beginWorkerInteractionUsingCtx = beginWorkerInteractionUsingCtx;
exports.getSettingsExn = getSettingsExn;
exports.getWrkCtxExn = getWrkCtxExn;
exports.getWrkParenCntExn = getWrkParenCntExn;
exports.getWrkFrmsExn = getWrkFrmsExn;
exports.getAllFramesInDeclarationOrderExn = getAllFramesInDeclarationOrderExn;
exports.getSyntaxTypesExn = getSyntaxTypesExn;
exports.processOnWorkerSide = processOnWorkerSide;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* settingsCache Not a pure module */
